<template>
<div id="person_application_outer" >

  <el-steps id="application_top_steps" :active="stepValue" finish-status="success" align-center>
    <el-step v-for="(item, index) in stepList" :key="'application_top_step' + index" :title="item"></el-step>
  </el-steps>
  <application-ready v-if="stepValue == 0" v-on:preview-image="showBigImage" v-on:submitSuccess="userInfoSubmitSuccess" />

  <verifiy-vue v-if="stepValue == 1"
               v-on:realNameVerifySuccess="userVerifySuccess"
               v-on:backToEditPage="resubmitButtonClicked"
			   v-on:nextStep="nextStepClicked"
               v-bind:next-button-text="'提交审核'"

  />

  <application-reviewing v-else-if="stepValue == 2"
                         v-on:nextClick="nextButtonClicked"
                         v-on:errorClick="resubmitButtonClicked"
                         v-on:forbidClick="forbidToHomePage"
                         :status="status" />
  <application-paying v-else-if="stepValue == 3"
                      v-on:paySuccess="paySuccess" />

  <success-vue v-else-if="stepValue == 4" v-on:gotoDetailPage="gotoVipDetailPage" />

  <el-dialog :visible.sync="dialogImageVisible">
    <img width="100%" :src="dialogImageUrl" >
  </el-dialog>

</div>
</template>

<script>
import ApplicationReady from "./personApplicationVues/ApplicationReady";
import GroupApplicationReady from "../group/groupApplicationVues/GroupApplicationReady";
import ApplicationReviewing from "./personApplicationVues/ApplicationReviewing";
import ApplicationPaying from "./personApplicationVues/ApplicationPaying";
import ApplicationInvoice from "./personApplicationVues/ApplicationInvoice";
import IdentificationVerificationVue from "../common/IdentificationVerificationVue";
import VipApplicationSuccess from "./personApplicationVues/VipApplicationSuccess";
import EventManager from "../../js/event-common";
export default {
  name: "PersonalVipApplication",
  components: {
    GroupApplicationReady,
    ApplicationReady,
    ApplicationReviewing,
    ApplicationPaying,
    ApplicationInvoice,
    VerifiyVue: IdentificationVerificationVue,
    SuccessVue: VipApplicationSuccess,
  },
  data() {
    return {
      title: '会员申请',
      dialogImageVisible: false,
      dialogImageUrl: null,
      status: 0, // 0 未申请 1 申请成功 2 待付款 3 通过, 4 审核未通过
      user: null,
      stepValue: 0,
      isUpdateUser: false,
      stepList: [
        '填写会员资料',
        '实名认证',
        '协会审核',
        '支付会员费'
      ],
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    eventManager() {
      return this.$store.state.eventManager;
    },
  },
  mounted() {
    this.initData();
    this.loadData();
  },
  methods: {
    dealWithUserData() {
      let user = this.user;
      if (user == null) {
        return;
      }
      let status = user.status;
      // status = 7;
      this.status = status;
      let auditStatus = user.auditStatus;
      let stepValue = -1;
      if (status == 0 || auditStatus == 0) { // 填写信息
        stepValue = 0;
      } else if (status == 8) { // 实名认证
        stepValue = 1;
      } else if (status == 1 || status == 2 || status == 4 || status == 7) { // 协会审核
        stepValue = 2;
      } else if (status == 9 ) { // 付款页面
        stepValue = 3;
      } else if (status == 3) { // 付款成功
        stepValue = 4;
      }
      // stepValue = 1;
      this.stepValue = stepValue;
      if (status == 1) {
        setTimeout(this.loadData, 10 * 1000);
      }
    },

    loadData() {
      if (this.isUpdateUser) {
        return;
      }
      this.isUpdateUser = true;
      let _this = this;
      this.httpManager.ajax.ucProfile(function (data) {
        _this.isUpdateUser = false;
        let code = data.code;
        if (code == 0) {
          let user = data.data;
          _this.$store.commit('setUser', user);
          _this.user = user;
        } else {
          _this.user = _this.$store.state.user;
        }
        _this.dealWithUserData();
      }, function (data) {
        _this.isUpdateUser = false;
        _this.user = _this.$store.state.user;
        _this.dealWithUserData();
      })
    },

    initData() {
    },

    showBigImage(res) {
      let imageUrl = res.imageUrl;
      this.dialogImageUrl = imageUrl;
      this.dialogImageVisible = true;
    },
	
	updateStatus() {
		let user = this.user;
		if (user == null) {
		  return;
		}
		let params = {};
		params.id = user.id;
		let memberValidDate = user.memberValidDate;
		let modified = user.modified;
		if (memberValidDate != null && modified == 0) { // 会员续期，未进行任何改动，跳转至付款界面
		  params.status = 9;
		} else { // 跳转值协会审核界面
		  params.status = 1;
		}
		
		let _this = this;
		this.httpManager.ajax.postUserUpdateStatusRequest(params, function (data) {
		  let code = data.code;
		  if (code == 0) {
		    _this.$toast('提交成功！');
			_this.loadData();
		    return;
		  }
		  _this.$toast('提交失败！');
		}, function (data) {
		  _this.$toast('提交失败，请重试！');
		});
	},
	nextStepClicked() {
		this.updateStatus();
	},
    userVerifySuccess() {
      this.loadData();
    },

    gotoVipDetailPage() {
      this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
      this.$router.push({
        name: 'personalMemberVue'
      });
    },

    nextButtonClicked() {
      this.loadData();
    },

    readyPaySubmitSuccess() {
      this.user = this.$store.state.user;
      this.status = this.user.status;
    },
    resubmitButtonClicked() {
      let user = this.$store.state.user;
      user.status = 0;
      this.$store.commit('setUser', user);
      this.user = user;
      this.stepValue = 0;
      // this.dealWithUserData();
    },
    forbidToHomePage() {
      this.eventManager.postNotification(EventManager.notificationNameObject.UserUpdate, {});
      this.$router.push({
        name: 'groupHomeVue'
      });
    },

    paySuccess() {
      let user = this.user;
      let params = {
        id: user.id,
        status: 3
      };
      let _this = this;
      this.httpManager.ajax.postUserUpdateStatusRequest(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.loadData();
          return;
        }
      }, function (data) {

      });
    },

    userInfoSubmitSuccess() {
      this.loadData();
    },
  }

}
</script>

<style scoped>

  #person_application_outer {
    margin-top: 30px;
    border: solid 1px #fc1a34;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-left: 5px;
    margin-right: 5px;
  }

  #application_top_steps {
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    margin-bottom: 30px;
  }

  @media screen and (min-width: 768px) {
    #application_top_steps {
      width: 80%;
    }
  }

  #application_top_steps /deep/ .el-step__title {
    font-size: 1rem;
    line-height: 1.5rem;
    margin-top: 15px;

  }

  #application_top_steps /deep/ .el-step__head.is-success {
    color: #666;
    border-color: #666;
  }

  #application_top_steps /deep/ .el-step__title.is-success {
    color: #666;
    font-weight: bold;
  }

  #application_top_steps /deep/ .el-step__head.is-process {
    color: #fc1a34;
    border-color: #fc1a34;
  }

  #application_top_steps /deep/ .el-step__title.is-process {
    color: #fc1a34;
  }

  #application_top_steps /deep/ .el-step__line {
    background-color: transparent;
    border-color: transparent;
  }

</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalVipApplication.vue